import React from "react";

const Newsletter = () => {
  return (
    // <div>
    //   <div className="bg-white border-t-4">
    //     <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:py-16 lg:px-8">
    //       <div className="px-6 py-6 md:px-12 lg:flex lg:items-center lg:px-16">
    //         <div className="lg:flex-1 xl:w-0">
    //           <h2 className="text-2xl font-extrabold tracking-tight text-black sm:text-3xl">
    //             Email Newsletter
    //           </h2>
    //           <p className="mt-3 max-w-3xl text-lg leading-6 text-black">
    //             Sign up for our email newsletter to stay up to date.
    //           </p>
    //         </div>
    //         <div className="mt-8 sm:w-full sm:max-w-md xl:mt-0 xl:ml-8">
    //           <form className="sm:flex" id="revue-form" target="_blank">
    //             <input
    //               type="email"
    //               autoComplete="email"
    //               required
    //               className="w-full rounded-md px-5 py-3 placeholder-gray-300 border border-gray-300 focus:outline-none focus:ring-0"
    //               placeholder="Enter your email"
    //             />
    //             <button
    //               type="submit"
    //               className="mt-3 flex w-full items-center justify-center rounded-md border border-transparent bg-black px-5 py-3 text-base font-medium  shadow hover:bg-[#f4a636] focus:outline-none focus:ring-0 sm:mt-0 sm:ml-3 sm:w-auto sm:flex-shrink-0"
    //             >
    //               Subscribe
    //             </button>
    //           </form>
    //           <p className="mt-3 text-sm text-black">
    //             We will never send any spam emails. Promise.
    //           </p>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
//     <div className="bg-white pb-8 pt-12">
//   <div className="max-w-7xl mx-auto px-4 lg:px-8">
//     <div className="grid md:grid-cols-2 items-center gap-12 md:gap-6 px-6 border rounded-md bg-white shadow-md py-12 sm:py-16 border-gray-300">
//       {/* Left Section: Content */}
//       <div className="order-2 md:order-1">
//         <h2 className="text-gray-800 text-2xl sm:text-3xl font-extrabold mb-2">
//           Subscribe to Our Newsletter
//         </h2>
//         <p className="text-sm sm:text-base text-gray-600">
//           Sign up for our email newsletter to stay up to date.
//         </p>
//         <div className="mt-8 flex flex-col sm:flex-row gap-4 sm:gap-6">
//           <input
//             type="email"
//             placeholder="Enter your email"
//             className="w-full bg-gray-50 border border-gray-300 placeholder:text-gray-800 py-3 px-4 text-gray-800 text-base focus:outline-none rounded"
//           />
//           <button className="bg-gray-800 hover:bg-gray-700  text-base font-semibold py-3 px-6 rounded focus:outline-none transition-all duration-300">
//             Subscribe
//           </button>
//         </div>
//       </div>
//       {/* Right Section: SVG */}
//       <div className="text-center flex justify-end order-1 md:order-2">
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           className="w-32 sm:w-40 md:w-60 mx-auto md:mx-0"
//           viewBox="0 0 512 512"
//         >
//           <path
//             fill="#64b5f6"
//             d="m0 192 246.528 156.896c2.816 2.08 6.144 3.104 9.472 3.104s6.656-1.024 9.472-3.104L512 192 265.6 3.2a16.032 16.032 0 0 0-19.2 0L0 192z"
//           />
//           <path
//             fill="#eceff1"
//             d="M416 0H96C78.368 0 64 14.368 64 32v352c0 8.832 7.168 16 16 16h352c8.832 0 16-7.168 16-16V32c0-17.632-14.336-32-32-32z"
//           />
//           <path
//             fill="#90a4ae"
//             d="M144 96h224c8.832 0 16-7.168 16-16s-7.168-16-16-16H144c-8.832 0-16 7.168-16 16s7.168 16 16 16zm224 32H144c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16s-7.168-16-16-16zm-96 64H144c-8.832 0-16 7.168-16 16s7.168 16 16 16h128c8.832 0 16-7.168 16-16s-7.168-16-16-16z"
//           />
//           <path
//             fill="#1e88e5"
//             d="M265.472 348.896c-2.816 2.08-6.144 3.104-9.472 3.104s-6.656-1.024-9.472-3.104L0 192v288c0 17.664 14.336 32 32 32h448c17.664 0 32-14.336 32-32V192L265.472 348.896z"
//           />
//           <path
//             fill="#2196f3"
//             d="M480 512H32c-17.952 0-32-14.048-32-32a16.02 16.02 0 0 1 6.528-12.896l240-160c2.816-2.08 6.144-3.104 9.472-3.104s6.656 1.024 9.472 3.104l240 160A16.02 16.02 0 0 1 512 480c0 17.952-14.048 32-32 32z"
//           />
//         </svg>
//       </div>
//     </div>
//   </div>
// </div>
<div className="bg-white ">
<div className="max-w-7xl mx-auto  p-6">
<div className="shadow-sm bg-white border p-5">
<div className="grid lg:grid-cols-2 items-center gap-10  mx-auto min-h-[350px]">
  <div>
    <h3 className=" text-4xl font-bold">Subscribe to Our Newsletter</h3>
    <p className="text-base mt-4 ">Get the latest updates, course announcements, and expert tips delivered straight to your inbox. Join our community today!</p>
    <div className="bg-transparent border border-gray-500 flex p-1 rounded-full mt-6">
      <input type="email" placeholder="Enter your email" className=" w-full outline-none  placeholder:text-gray-700 bg-transparent text-sm px-4 py-3" />
      <button type="button" className="bg-blue-700 hover:bg-blue-800 transition-all text-white  text-sm rounded-full px-6 py-3">Submit</button>
    </div>
  </div>
  <div className="grid md:grid-cols-2 gap-8">
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" className="fill-blue-600 w-12 mb-6 inline-block border border-gray-500 p-3 rounded-md" viewBox="0 0 32 32">
        <path d="M28.068 12h-.128a.934.934 0 0 1-.864-.6.924.924 0 0 1 .2-1.01l.091-.091a2.938 2.938 0 0 0 0-4.147l-1.511-1.51a2.935 2.935 0 0 0-4.146 0l-.091.091A.956.956 0 0 1 20 4.061v-.129A2.935 2.935 0 0 0 17.068 1h-2.136A2.935 2.935 0 0 0 12 3.932v.129a.956.956 0 0 1-1.614.668l-.086-.091a2.935 2.935 0 0 0-4.146 0l-1.516 1.51a2.938 2.938 0 0 0 0 4.147l.091.091a.935.935 0 0 1 .185 1.035.924.924 0 0 1-.854.579h-.128A2.935 2.935 0 0 0 1 14.932v2.136A2.935 2.935 0 0 0 3.932 20h.128a.934.934 0 0 1 .864.6.924.924 0 0 1-.2 1.01l-.091.091a2.938 2.938 0 0 0 0 4.147l1.51 1.509a2.934 2.934 0 0 0 4.147 0l.091-.091a.936.936 0 0 1 1.035-.185.922.922 0 0 1 .579.853v.129A2.935 2.935 0 0 0 14.932 31h2.136A2.935 2.935 0 0 0 20 28.068v-.129a.956.956 0 0 1 1.614-.668l.091.091a2.935 2.935 0 0 0 4.146 0l1.511-1.509a2.938 2.938 0 0 0 0-4.147l-.091-.091a.935.935 0 0 1-.185-1.035.924.924 0 0 1 .854-.58h.128A2.935 2.935 0 0 0 31 17.068v-2.136A2.935 2.935 0 0 0 28.068 12ZM29 17.068a.933.933 0 0 1-.932.932h-.128a2.956 2.956 0 0 0-2.083 5.028l.09.091a.934.934 0 0 1 0 1.319l-1.511 1.509a.932.932 0 0 1-1.318 0l-.09-.091A2.957 2.957 0 0 0 18 27.939v.129a.933.933 0 0 1-.932.932h-2.136a.933.933 0 0 1-.932-.932v-.129a2.951 2.951 0 0 0-5.028-2.082l-.091.091a.934.934 0 0 1-1.318 0l-1.51-1.509a.934.934 0 0 1 0-1.319l.091-.091A2.956 2.956 0 0 0 4.06 18h-.128A.933.933 0 0 1 3 17.068v-2.136A.933.933 0 0 1 3.932 14h.128a2.956 2.956 0 0 0 2.083-5.028l-.09-.091a.933.933 0 0 1 0-1.318l1.51-1.511a.932.932 0 0 1 1.318 0l.09.091A2.957 2.957 0 0 0 14 4.061v-.129A.933.933 0 0 1 14.932 3h2.136a.933.933 0 0 1 .932.932v.129a2.956 2.956 0 0 0 5.028 2.082l.091-.091a.932.932 0 0 1 1.318 0l1.51 1.511a.933.933 0 0 1 0 1.318l-.091.091A2.956 2.956 0 0 0 27.94 14h.128a.933.933 0 0 1 .932.932Z" data-original="#000000" />
        <path d="M16 9a7 7 0 1 0 7 7 7.008 7.008 0 0 0-7-7Zm0 12a5 5 0 1 1 5-5 5.006 5.006 0 0 1-5 5Z" data-original="#000000" />
      </svg>
      <h3 className=" text-xl font-semibold mb-3">Customization</h3>
      <p className=" text-sm text-justify">Tailor your learning experience to fit your needs. Our flexible courses let you learn at your own pace, anytime, anywhere.
      </p>
    </div>
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" className="w-12 mb-6 inline-block border border-gray-500 p-3 rounded-md" viewBox="0 0 682.667 682.667">
        <defs>
          <clipPath id="a" clipPathUnits="userSpaceOnUse">
            <path d="M0 512h512V0H0Z" data-original="#000000" />
          </clipPath>
        </defs>
        <g fill="none" className="stroke-blue-600" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} strokeWidth={40} clipPath="url(#a)" transform="matrix(1.33 0 0 -1.33 0 682.667)">
          <path d="M256 492 60 410.623v-98.925C60 183.674 137.469 68.38 256 20c118.53 48.38 196 163.674 196 291.698v98.925z" data-original="#000000" />
          <path d="M178 271.894 233.894 216 334 316.105" data-original="#000000" />
        </g>
      </svg>
      <h3 className=" text-xl font-semibold mb-3">Security</h3>
      <p className=" text-sm text-justify">Your data and privacy are our top priority. We ensure a safe and secure learning environment for all our users.</p>
    </div>
  </div>
</div>
</div>
</div>
</div>
  );
};

export default Newsletter;
